'use client';


import {Component, useState} from "react";
import React from "react";
import UserEntity from "../../types/userEntity.type";

type Props = {
    listItems: UserEntity[] | [];
};

export default class AdminsList extends Component<Props> {


    constructor(props: Props) {
        super(props);

        this.state = {
            content: null
        };
    }


    render() {

        console.log(this.props.listItems);

        const listItems = Array.from(this.props.listItems).map((d) =>
            <>
                <tr>
                    <td scope="row" key={d.id}>{d.email}</td>
                    <td>{d.fullname}</td>
                    <td>{d.contact}</td>
                    <td>{d.role}</td>
                    <td>{d.enabled ? (
                        <>Yes</>
                    ) : (
                        <>No</>
                    )}</td>
                    <td>{d.addsRemoved ? (
                        <>Yes</>
                    ) : (
                        <>No</>
                    )}</td>
                    <td>{d.expired ? (
                        <>No</>
                    ) : (
                        <>Yes</>
                    )}</td>
                    <td>{d.createdAt}</td>

                    <td>
                        <button onClick={() => window.location.replace("user/" + d.id)}
                                className="btn btn-primary btn-block">Edit
                        </button>
                        <br/>
                        <button onClick={() => window.location.replace("user/" + d.id)}
                                className="btn btn-primary btn-block">Delete
                        </button>
                    </td>
                </tr>
            </>
        );
        return (
            <>
                <table>
                    <thead>
                    <tr>
                        <th scope="col">Email</th>
                        <th scope="col">Fullname</th>
                        <th scope="col">Contact</th>
                        <th scope="col">Role</th>
                        <th scope="col">Enabled</th>
                        <th scope="col">Adds</th>
                        <th scope="col">Expired</th>
                        <th scope="col">Created</th>
                        <th scope="col">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {listItems}
                    </tbody>
                </table>
            </>
        );
    }
}